import React, { useEffect, useState } from "react";
import AddressComponent from "../../components/AddressComponent";
import LockIcon from "../../assets/padlock.svg";
import notify from "../../components/UI/toast";
import {
  addAddress,
  deleteAddress,
  getAddresses,
  editAddresses,
} from "../../components/AddressComponent/services/addressService";
import { useUserData } from "../../hooks/UserContext";
import { Container, Row, Col } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import PersonalAddressList from "../../components/AddressComponent/personalAddressList";
import {
  isFixedAddress,
  SAFRA_FIXED_ADDRESS_MESSAGE,
  extractSavedAddressFromResponse,
  mergeSavedAddressMain,
} from "../../components/AddressComponent/addressUtils";
import { capitalizeFirstLetter } from "../../extension/string.ts";
import ModalApp from "../../components/ModalApp";
import { cardsApi } from "../OrderResumePag/_services/api";
import { Text, SectionTitle, InputFieldsWrapper, RegisteredCards } from "./styles";
import { Divider } from "@mui/material";
import { useNavigate } from "react-router";
import { PencilSimpleLine } from "@phosphor-icons/react";
import EmailModal from "./_components/EmailModal";
import { updateCustomerEmail } from "./_services/customerService";
import { trackClick } from "../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../utils/marketplaceTagIds";
import { useScreenTracking } from "../../hooks/useScreenTracking";
import {
  getCustomerFromMemory,
  setCustomerInMemory,
} from "../../lib/sharedSessionMemory";
import { RegisterNewCard } from "../MyAccount/_components/RegisterNewCard";

function formatCnpj(value) {
  if (!value) return "";
  const digits = value.replace(/\D/g, "").slice(0, 14);
  return digits.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
}

function formatCpf(value) {
  if (!value) return "";
  const digits = value.replace(/\D/g, "").slice(0, 11);
  return digits.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
}

export default function MyAccountPJ() {
  const screenName = useScreenTracking();
  const [Loading, setLoading] = useState(true);
  const [cards, setCards] = useState([]);
  const [address, setAddress] = useState({});
  const [addresses, setAddresses] = useState([]);
  const [open, setOpen] = useState(false);
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [pfEmail, setPfEmail] = useState("");
  const [refreshCards, setRefreshCards] = useState();
  const [isLoading, setIsLoading] = useState(null);
  const { user } = useUserData();
  const jwt = useUserData();
  // eslint-disable-next-line
  const customer_address = jwt?.addressesData || [];
  const dataUser = jwt?.userData.data;
  const navigate = useNavigate();

  async function handleEndereco(address) {
    let result = null;
    address.customerUuid = dataUser.uuid;

    if (isFixedAddress(address)) {
      notify(SAFRA_FIXED_ADDRESS_MESSAGE, "info");
      return;
    }

    try {
      if (address.uuid) {
        result = await editAddresses(address);
      } else {
        result = await addAddress(address);
      }

      if (!result.status) {
        notify(result.data.message, "error");
        return;
      }

      notify(result.data.message, "success");

      trackClick({
        title: address.uuid ? "salvar" : "adicionar",
        contentType: address.uuid
          ? "atualizar-dados-do-endereco"
          : "cadastrar-novo-endereco",
        screenName,
        tagId: tagIdFromLegacySuffix("07"),
      });

      jwt.setUpdateAddresses(new Date());

      const updatedAddresses = await getAddresses();
      const savedAddress = extractSavedAddressFromResponse(result);
      const targetUuid = address.uuid || savedAddress?.uuid;
      const savedMain = savedAddress?.main ?? address.main;

      setAddresses(
        mergeSavedAddressMain(updatedAddresses, targetUuid, savedMain),
      );
      setOpen(false);
    } catch (error) {
      console.error("Erro ao salvar endereço:", error);
      notify("Erro ao atualizar endereço", "error");
    }
  }

  async function onClickDelAddress(uuidAddress) {
    const targetAddress = addresses.find((item) => item.uuid === uuidAddress);

    if (isFixedAddress(targetAddress)) {
      notify(SAFRA_FIXED_ADDRESS_MESSAGE, "info");
      return;
    }

    let message = "";
    let type = "success";

    try {
      const response = await deleteAddress(uuidAddress);
      message = response.message;

      trackClick({
        title: "excluir",
        contentType: "atualizar-dados-do-endereco",
        screenName,
        tagId: tagIdFromLegacySuffix("07"),
      });

      // Atualizar a listagem de endereços após deletar
      const updatedAddresses = await getAddresses();
      setAddresses(updatedAddresses);
    } catch (error) {
      message = error.message;
      type = "error";
    } finally {
      notify(message, type);
      jwt.setUpdateAddresses(new Date());
    }
  }

  useEffect(() => {
    if (dataUser) {
      const fetchData = async () => {
        const cardResponse = await getCard();
        const cardsArr = cardResponse || [];
        setCards(() => [...cardsArr]);

        const userAddresses = await getAddresses();
        setAddresses(userAddresses);

        setLoading(false);
      };
      fetchData();
    }
  }, [dataUser, Loading, refreshCards]);

  useEffect(() => {
    if (dataUser?.email) {
      setPfEmail(dataUser.email);
    }
  }, [dataUser]);

  function adicionarEndereco() {
    trackClick({
      title: "adicionar",
      contentType: "enderecos-cadastrados",
      screenName,
      tagId: tagIdFromLegacySuffix("06"),
    });

    setAddress({});
    setOpen(true);
  }

  function onOpenEmailModal() {
    trackClick({
      title: "alterar",
      contentType: "dados-pessoais",
      screenName,
      tagId: tagIdFromLegacySuffix("06"),
    });

    setOpenEmailModal(true);
  }

  function onCloseEmailModal() {
    setOpenEmailModal(false);
  }

  async function onSaveEmail(updatedEmail) {
    if (!updatedEmail || !updatedEmail.includes("@")) {
      notify("Informe um e-mail válido.", "error");
      return;
    }

    try {
      setIsLoading(true);
      const response = await updateCustomerEmail(dataUser.cpf, updatedEmail);

      if (response.status !== 200) {
        notify("Erro ao atualizar o e-mail.", "error");
        return;
      }

      // Atualiza o estado local
      setPfEmail(updatedEmail);

      // Atualiza o estado compartilhado com o novo e-mail
      const userData = getCustomerFromMemory();
      if (userData) {
        userData.data.email = updatedEmail;
        setCustomerInMemory(userData);
        jwt.setUpdateUser(new Date());
      }

      notify("E-mail atualizado com sucesso.", "success");

      trackClick({
        title: "salvar",
        contentType: "dados-pessoais",
        screenName,
        tagId: tagIdFromLegacySuffix("07"),
      });

      setOpenEmailModal(false);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Erro ao atualizar e-mail:", error);
      const errorMessage =
        error.response?.data?.message || "Erro ao atualizar o e-mail.";
      notify(errorMessage, "error");
    } finally {
      setIsLoading(false);
    }
  }

  async function getCard() {
    try {
      const { data, status } = await cardsApi.get(
        `/v1/customer/card`,
      );

      if (status !== 200) {
        notify("Erro ao obter os dados do cartão", "error");
        return;
      }

      return data.data;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
      notify("Erro ao obter os dados do cartão.", "error");
    }
  }

  return (
    !Loading && (
      <>
        <ModalApp
          show={open}
          handleModal={() => {
            trackClick({
              title: "fechar-modal",
              contentType: "cadastrar-novo-endereco",
              screenName,
              tagId: tagIdFromLegacySuffix("07"),
            });
            setOpen(false);
          }}
        >
          <AddressComponent
            onConfirm={handleEndereco}
            onCancel={() => setOpen(false)}
            address={address}
          />
        </ModalApp>
        <EmailModal
          show={openEmailModal}
          defaultEmail={pfEmail}
          onClose={onCloseEmailModal}
          onSave={onSaveEmail}
        />
        <div className="wl-page">
          {/* Dados da empresa */}
          {console.log(jwt?.companyData)}
          <Container>
            <SectionTitle style={{ marginTop: "41px", marginBottom: "24px" }}>
              Dados da empresa
            </SectionTitle>
            <InputFieldsWrapper>
            <div className="group-disabled-color color-opacty-60">
              <div className="input-group" style={{ marginBottom: "18px" }}>
                <TextField
                  type="text"
                  className="w-100"
                  placeholder="Nome"
                  value={jwt?.companyData?.nome}
                  variant="standard"
                  readOnly
                />
                <span className="input-group-wl">
                  <img
                    src={LockIcon}
                    style={{ height: 16, width: 16 }}
                    className="text-black"
                    alt="lock"
                  />
                </span>
              </div>

              <div className="input-group" style={{ marginBottom: "18px" }}>
                <TextField
                  type="text"
                  className="w-100"
                  placeholder="CNPJ"
                  value={formatCnpj(jwt?.companyData?.cpf)}
                  variant="standard"
                  readOnly
                />
                <span className="input-group-wl">
                  <img
                    src={LockIcon}
                    style={{ height: 16, width: 16 }}
                    className="text-black"
                    alt="lock"
                  />
                </span>
              </div>

              <div className="input-group" style={{ marginBottom: "18px" }}>
                <TextField
                  type="text"
                  className="w-100"
                  placeholder="Email"
                  value={jwt?.companyData?.email}
                  variant="standard"
                  readOnly
                />
                <span className="input-group-wl">
                  <img
                    src={LockIcon}
                    style={{ height: 16, width: 16 }}
                    className="text-black"
                    alt="lock"
                  />
                </span>
              </div>
            </div>
            </InputFieldsWrapper>
          </Container>

          {/* Responsável */}
          {console.log(dataUser)}
          <Container>
            <SectionTitle style={{ marginTop: "36px", marginBottom: "24px" }}>
              Responsável
            </SectionTitle>
            <InputFieldsWrapper>
            <div className="group-disabled-color color-opacty-60">
              <div className="input-group" style={{ marginBottom: "18px" }}>
                <TextField
                  type="text"
                  className="w-100"
                  placeholder="Nome"
                  value={capitalizeFirstLetter(dataUser.nome) + " " + capitalizeFirstLetter(dataUser.sobrenome)}
                  variant="standard"
                  readOnly
                />
                <span className="input-group-wl">
                  <img
                    src={LockIcon}
                    style={{ height: 16, width: 16 }}
                    className="text-black"
                    alt="lock"
                  />
                </span>
              </div>

              <div className="input-group" style={{ marginBottom: "18px" }}>
                <TextField
                  type="text"
                  className="w-100"
                  placeholder="CPF"
                  value={formatCpf(dataUser.cpf)}
                  variant="standard"
                  readOnly
                />
                <span className="input-group-wl">
                  <img
                    src={LockIcon}
                    style={{ height: 16, width: 16 }}
                    className="text-black"
                    alt="lock"
                  />
                </span>
              </div>

              <div className="input-group" style={{ marginBottom: "18px" }}>
                <TextField
                  type="text"
                  className="w-100"
                  placeholder="Digite um e-mail válido"
                  value={pfEmail}
                  variant="standard"
                  onClick={!pfEmail ? onOpenEmailModal : undefined}
                  InputProps={{ readOnly: true }}
                  style={{ cursor: !pfEmail ? "pointer" : "default" }}
                />
                <span
                  className="input-group-wl"
                  onClick={!pfEmail ? onOpenEmailModal : undefined}
                  style={{ cursor: !pfEmail ? "pointer" : "default" }}
                >
                  {pfEmail ? (
                    <img
                      src={LockIcon}
                      style={{ height: 16, width: 16 }}
                      className="text-black"
                      alt="lock"
                    />
                  ) : (
                    <PencilSimpleLine size={18} weight="regular" />
                  )}
                </span>
              </div>
            </div>
            </InputFieldsWrapper>
          </Container>

          {/* Endereços cadastrados */}
          <Container style={{ marginTop: "36px" }}>
            <Text className="mt-4">
              <SectionTitle style={{ marginBottom: "32px" }}>
                Endereços cadastrados
              </SectionTitle>
              <PersonalAddressList
                addresses={Array.isArray(addresses) ? addresses : []}
                onClickDelAddress={onClickDelAddress}
                setAddress={setAddress}
                setOpen={setOpen}
                open={open}
                address={address}
                handleEndereco={handleEndereco}
                screenName={screenName}
              />
            </Text>
            <Row>
              <Col className="my-4">
                <button
                  className="btn-outline-wl px-4 py-2 text-xs font-wl-700"
                  style={{ width: "fit-content" }}
                  onClick={adicionarEndereco}
                >
                  ADICIONAR ENDEREÇO
                </button>
              </Col>
            </Row>
          </Container>

          {/* Cartões cadastrados */}
          <Container style={{ marginTop: "36px" }}>
            <RegisteredCards>
              <SectionTitle style={{ marginBottom: "32px" }}>
                Cartões cadastrados
              </SectionTitle>
              <RegisterNewCard
                addresses={Array.isArray(addresses) ? addresses : [addresses]}
                cards={cards}
                setCards={setCards}
                setRefreshCards={setRefreshCards}
              />
            </RegisteredCards>
          </Container>

          <Divider style={{ margin: "20px 24px", marginBottom: "56px" }} />

          <Container
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
              marginBottom: "41px",
            }}
          >
            <button
              className="btn-default-wl"
              style={{
                width: "187px",
                height: "30px",
                background: "var(--button-primary-color)",
                color: "var(--secondary-color)",
                textAlign: "center",
                fontFamily: "var(--font-family)",
                fontSize: "10px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "100%",
                textTransform: "uppercase",
              }}
              onClick={() => {
                trackClick({
                  title: "ir-para-home",
                  contentType: "navegacao",
                  screenName,
                  tagId: tagIdFromLegacySuffix("06"),
                });
                navigate("/");
              }}
            >
              IR PARA HOME
            </button>
          </Container>
        </div>
      </>
    )
  );
}
